import React, { useEffect, useState } from "react";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import DoctorTeams from "./doctorTeam";
import { useTranslation } from "react-i18next";

function Overview() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <SeoAdd slug={ROUTE.OVERVIEW} />
      <BreadCrumb page={t("about_us")} data={{ slug: "", path: "#" }} />
      <section className="categories about-section pt-3">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap about-usW100">
                <div className="text-center">
                  <img
                    src={t("images.overview_banner")}
                    className="scale"
                    alt=""
                  />
                </div>
                <div className="headingmains text-center pb-3">
                  <h2 className="right aos-init pb-2 mt-3 mt-lg-5">
                    {t("about_overview")}
                  </h2>
                </div>
                <p className="text-center dull_heading pb-3">
                  {t("about_note")}
                </p>
                <p
                  className="f-16 text-center mb-3"
                  style={{ maxWidth: "85%", margin: "0 auto" }}
                >
                  {t("about_desc")}
                </p>
                <p
                  className="f-16 text-center mb-3"
                  style={{ maxWidth: "85%", margin: "0 auto" }}
                >
                  {t("about_desc_")}
                </p>
                <p
                  className="f-16 text-center mb-3"
                  style={{ maxWidth: "85%", margin: "0 auto" }}
                >
                  {t("about__desc")}
                </p>
                <p
                  className="f-16 text-center mb-3"
                  style={{ maxWidth: "85%", margin: "0 auto" }}
                >
                  {t("about__desc_")}
                </p>
                <p
                  className="f-16 text-center mb-3"
                  style={{ maxWidth: "85%", margin: "0 auto" }}
                >
                  {t("about_desc__")}
                </p>
              </div>
            </div>
          </div>
          <div className="row keybusiness">
            <div className="col-12">
              <h4 className="head2">{t("about_key")}</h4>
            </div>
            <div className="col-12">
              <ul
                className={
                  i18n.language === "ta"
                    ? "tamil-class-keyf keyflow"
                    : "keyflow"
                }
              >
                <li>
                  <h5>
                    {t("about_specialized")} <br /> {t("about_diagnostics")}
                  </h5>
                  <p>
                    {t("about_biology")}
                    <br /> {t("about_flow_cytometry")} <br />{" "}
                    {t("about_surgical")} <br />
                    {t("about_ihc")}
                    <br />
                    {t("about_cytogenetics")}
                  </p>
                </li>
                <li>
                  <h5>{t("about_rd")}</h5>
                  <p>
                    {t("about_pioneer")} <br /> {t("about_advanced")}
                    <br /> {t("about_market")}
                  </p>
                </li>
                <li>
                  <h5>
                    {t("about_hospital_lab")}
                    <br /> {t("about_mamangement")}
                  </h5>
                  <p>
                    {t("about_partner")} <br />
                    {t("about_hospital")}
                    <br /> {t("about_optimize")} <br /> {t("about_operation")}
                  </p>
                </li>
                <li>
                  <h5>{t("about_clinical_trials")}</h5>
                  <p>
                    {t("about_pharma")}
                    <br /> {t("about_cros")}
                    <br /> {t("about_support")}
                  </p>
                </li>
                <li>
                  <h5>
                    {t("about_routine")} <br /> {t("about_diagnostics")}
                  </h5>
                  <p>
                    {t("about_biochemistry")}
                    <br />
                    {t("about_microbiology")}
                    <br /> {t("about_immunoassays")}{" "}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sub-section bg-grey home-services overview_highlight mt-md-0 mt-2 pad0-over-high">
        <div className="container">
          <div className="text-center">
                
                  <h4 className="head2 py-5">{t("partner_highlights")}</h4>
                
          </div>
          <div className="row">
            <div className="col-12">
              <ul>
                
                <li>
                  <h5>
                    {t("about_extensive")} <br />
                    {t("about_test_menu")}
                  </h5>
                  <p>{t("about_test_text")}</p>
                </li>
                <li>
                  <h5>
                    {t("about_footprints")}
                    <br /> {t("about_spans")}
                  </h5>
                  <p>{t("about_labs_count")}</p>
                </li>
                <li>
                  <h5>
                    {t("about_highly")} <br />
                    {t("about_trusted")}
                  </h5>
                  <p>{t("about_trust_text")}</p>
                </li>
                <li>
                  <h5>
                    {t("about_leader")} <br />
                    {t("about_testing")}
                  </h5>
                  <p>{t("about_leader_text")}</p>
                </li>
                <li>
                  <h5>
                    {t("about_laboratory")} <br /> {t("about_accreditations")}
                  </h5>
                  <p>{t("about_accreditations_text")}</p>
                </li>
                <li>
                  
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <DoctorTeams />
      <section className="overview_network about-section mt-3 mt-lg-5">
        <div className="container">
          {/* <div className="row ">
            <div className="col-sm-12">
              <h4 className="head2">
                {t("about_oncquest_leading")} <br />
                {t("about_super_specialised")}
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <img
                src={t("images.overview01")}
                className="scale for-radius"
                alt=""
              />
            </div>
            <div className="col-md-6">
              <ul className="mission">
                <li>
                  <p>
                    <b>{t("about_list_text")}</b>
                  </p>
                </li>
                <li>
                  <p>
                    <b>{t("about_list_text1")}</b>
                  </p>
                </li>
                <li>
                  <p>
                    <b>{t("about_list_text2")}</b>
                  </p>
                </li>
                <li>
                  <p>
                    <b>{t("about_list_text3")}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div> */}

          <div className="row network2">
            <div className="col-12">
              <h4 className="head2">{t("about_internation_network")}</h4>
              <h3 className="text-center">
                <span>{t("about_nepal")}</span> |{" "}
                <span>{t("about_bangladesh")}</span> |{" "}
                <span>{t("about_srilanka")}</span> |{" "}
                <span>{t("about_uzbekistan")}</span>
              </h3>
            </div>
          </div>
        </div>
      </section>


      {/* <div className="journey-bg">
        <div className="bg-jrny">
          <h1 className="text-center">{t("about_journey")}</h1>
          <section id="ov-timeline" className="container mt0">
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                {" "}
                <span></span>
              </div>
              <div className="ov-timeline-content">
                <p>
                  {t("about_molecular")} <br /> {t("about_research_lab")}
                </p>

                <span className="cd-date datebg">{t("2002")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>
                  {t("about_year_text1")}
                  <br />
                  {t("about_year_text_1")}
                </p>
                <span className="cd-date datebg">{t("2003")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>
                  {t("about_year_text2")}
                  <br />
                  {t("about_year_text_2")}
                </p>
                <span className="cd-date datebg">{t("2006")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>
                  {t("about_year_text3")}
                  <br />
                  {t("about_year_text_3")}
                </p>
                <span className="cd-date datebg">{t("2010")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>{t("about_year_text4")}</p>
                <span className="cd-date datebg">{t("2011")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>{t("about_year_text5")}</p>
                <span className="cd-date datebg">{t("2017")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>{t("about_year_text6")} </p>
                <span className="cd-date datebg">{t("2018")}</span>
              </div>
            </div>
            <div className="ov-timeline-block">
              <div className="ov-timeline-img cd-picture bounce-in">
                <span></span>{" "}
              </div>
              <div className="ov-timeline-content">
                <p>
                  {t("about_year_text7")}
                  <br /> {t("about_year_text_7")}
                </p>
                <span className="cd-date datebg">{t("2020")}</span>
              </div>
            </div>
          </section>
        </div>
      </div> */}
      
      <section className="overview-bottom about-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p>{t("about_description")}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="buniyad-bg def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                  Buniyaad
                </h3>
                <p className="text-center pl-2 pr-2">Our Journey so far</p>
              </div>
              <div className="about-sec-img text-center">
                <img
                  className="scale"
                  src="/assets/img/buniyad-img.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="jariya-bg def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">Jariya</h3>
                <p className="text-center pl-2 pr-2">
                  Technical Platform Update
                </p>
              </div>
              <div className="about-sec-img text-center">
                <img
                  className="scale"
                  src="/assets/img/jariya-img.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="buniyad-bg def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                  In-House R&D
                </h3>
              </div>
              <div className="about-sec-img text-center about-sec-width">
                <img
                  className="scale text-center"
                  src="/assets/img/in-house.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="jariya-bg def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                  Clinical Trials & Patient <br />
                  Support Programs
                </h3>
              </div>
              <div className="about-sec-img text-center about-sec-width">
                <img
                  className="scale"
                  src="/assets/img/clinical-trial.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="buniyad-bg def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                  4000 + Test Range Coveringspecialised <br /> & Retail Segment
                </h3>
              </div>
              <div className="about-sec-img text-center about-sec-width">
                <img
                  className="scale text-center"
                  src="/assets/img/retail-segment.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="core-strengths def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                  Our Core Strengths
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="about-sec-img text-center">
                <img
                  className="scale text-center for-radius"
                  src="/assets/img/core-stre-img.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="core-st-content">
                <ul>
                  <li>
                    <strong>Heritage:</strong> Oncquest is promoted by the
                    Burman family, the promoters of Dabur. It Inherits the
                    strong values, trust and commitment of Dabur.
                  </li>
                  <li>
                    <strong>Experience:</strong> Oncquest’s Combined Doctors’
                    experience exceeds 600+ years.
                  </li>
                  <li>
                    <strong>Quality:</strong> Oncquest follows stringent quality
                    norms and is NABL accredited.
                  </li>
                  <li>
                    <strong>Pioneers:</strong> Oncquest has brought many hi-end
                    International technologies in India.
                  </li>
                  <li>
                    <strong>Leader:</strong> Oncquest is leader in Oncology
                    testing.
                  </li>
                  <li>
                    <strong>Personalised:</strong> Service and commitment to
                    partners.
                  </li>
                  <li>
                    <strong>Final Diagnostics:</strong> Conclusive reports,
                    Reflex testing
                  </li>
                  <li>
                    <strong>Specialised phlebotomy:</strong> Trained for
                    Paediatrics & Senior Citizens.
                  </li>
                  <li>
                    <strong>Most accurate reports:</strong> Reports that inspire
                    Doctor confidence
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="india-network def-about-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="headingmains text-center pb-3">
                <h3 className="right aos-init pb-2 text-capitalize ">
                Our Network
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="core-st-content">
                <ul>
                  <li>
                    <strong>National Footprint:</strong><p>Spans 30+ Labs, 400+ Collection Centres & 
2500+ Service Associates.</p>
                  </li>
                  <li>
                    <strong>National Reference Laboratory:</strong><p>A-17 Info City-1, Sector 34, Gurugram, Haryana 122001.</p>
                  </li>
                  <li>
                    <strong>Regional Reference Labs:</strong><p>New Delhi, Bengaluru & Kolkata</p>
                  </li>
                  <li>
                    <strong>Satellite Labs:</strong><p>Bathinda, Barrackpore,
                    Bhubaneswar, Bhopal, Cuttack, Delhi, Gurugram,
                    Guwahati, Hyderabad, Jalandhar, Jhansi, Kanpur,
                    Kolkata, Ludhiana, Lucknow, Mumbai, Nashik, Panchkula,
                    Patna, Pune, Rajamahendravaram, Raipur, Srinagar, Varanasi</p>
                  </li>
                  <li>
                    <strong>International Network:</strong><p>Nepal, Bangladesh,
                    Sri Lanka, Uzbekistan</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="text-center">
                <img
                  className="scale text-center"
                  src="/assets/img/india-network.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Overview;
